import { createFileRoute } from "@tanstack/react-router";
import { TrainingJobDetail } from "../../features/training/trainingjob-detail";

export const Route = createFileRoute("/_authed/$org/$project/trainingjobs/$name/$tab")({ component: TrainingJobPage });

function TrainingJobPage() {
  const { org, project, name, tab } = Route.useParams();
  return <TrainingJobDetail scope={{ org, project }} name={name} tab={tab} />;
}
